import {
    useGetAllDealerAdressBrandTechnicalSupportResponsibleQuery,
    useCreateDealerAdressBrandTechnicalSupportResponsibleMutation,
    useUpdateDealerAdressBrandTechnicalSupportResponsibleMutation
} from '../../../../../api';
import { useGetUserGroupsQuery } from '../../../../../api';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateForApi } from '../../../../../utils/dateUtils';

import { useState } from 'react';

export const useTechnicalSupportResponsibleData = ({ dealerAddressBrandId, dealerAddress, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();

    const [pageNumber, setPageNumber] = useState(1);

    const { data: userGroupsResponse } = useGetUserGroupsQuery();

    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAdressBrandTechnicalSupportResponsibleQuery(
        {
            addressBrandId: dealerAddressBrandId,
            pageNumber,
            pageSize
        },
        { skip: !enabled }
    );

    const getUserNameById = (id) => {
        return userGroupsResponse?.data?.find((user) => user.id === id)?.name || id;
    };

    const [createTechnicalSupportResponsible] = useCreateDealerAdressBrandTechnicalSupportResponsibleMutation();
    const [updateTechnicalSupportResponsible] = useUpdateDealerAdressBrandTechnicalSupportResponsibleMutation();

    const getResponsibilityOrderLabel = (order) => {
        if (order == null) return '-';
        if (Number(order) === 1) return th('customerAddressBrand.tabs.technicalSupportResponsible.responsibilityOrder.primary');
        return th('customerAddressBrand.tabs.technicalSupportResponsible.responsibilityOrder.ordered', { order: Number(order) });
    };

    const createResponsibilityOrderOptions = (length) =>
        Array.from({ length }, (_, index) => ({
            value: index + 1,
            label: getResponsibilityOrderLabel(index + 1)
        }));

    const responsibilityOrderOptions = {
        create: createResponsibilityOrderOptions(data.count + 1),
        update: createResponsibilityOrderOptions(data.count)
    };
    const nextResponsibilityOrder = data.count + 1;

    const columns = [
        {
            field: 'userName',
            header: th('customerAddressBrand.tabs.technicalSupportResponsible.columns.userName'),
            body: (row) => row.userName || getUserNameById(row.userId)
        },
        {
            field: 'responsibilityOrder',
            header: th('customerAddressBrand.tabs.technicalSupportResponsible.columns.responsibilityOrder'),
            body: (row) => getResponsibilityOrderLabel(row.responsibilityOrder)
        },
        {
            field: 'contractStartDate',
            header: th('customerAddressBrand.tabs.technicalSupportResponsible.columns.contractStartDate'),
            bodyField: 'contractStartDate'
        },
        {
            field: 'contractEndDate',
            header: th('customerAddressBrand.tabs.technicalSupportResponsible.columns.contractEndDate'),
            bodyField: 'contractEndDate'
        },
        { field: 'description', header: th('customerAddressBrand.tabs.technicalSupportResponsible.columns.description') }
    ];

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,
                    dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    userId: Number(formData.userId) || 0,
                    contractStartDate: formData.contractStartDate ? formatDateForApi(formData.contractStartDate) : null,
                    contractEndDate: formData.contractEndDate ? formatDateForApi(formData.contractEndDate) : null,
                    responsibilityOrder: Number(formData.responsibilityOrder),
                    description: formData.description || '',
                    isActive: 1
                };
                await updateTechnicalSupportResponsible(payload).unwrap();
                console.log('✅ Technical Support Responsible güncellendi', payload);
            } else {
                const payload = {
                    dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    userId: Number(formData.userId) || 0,
                    contractStartDate: formData.contractStartDate ? formatDateForApi(formData.contractStartDate) : null,
                    contractEndDate: formData.contractEndDate ? formatDateForApi(formData.contractEndDate) : null,
                    responsibilityOrder: Number(formData.responsibilityOrder),
                    description: formData.description || ''
                };
                await createTechnicalSupportResponsible(payload).unwrap();
                console.log('✅ Technical Support Responsible oluşturuldu', payload);
            }
            refetch();
        } catch (err) {
            console.error('❌ Technical Support Responsible kayıt hatası:', err);
        }
    };

    return {
        items: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        responsibilityOrderOptions,
        nextResponsibilityOrder,
        save,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize
    };
};

